import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDeviceType } from '../../hooks/use-device-type';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const options = [
		{
				label: 'O mnie',
				href: '/about-me',
		},
		{
				label: 'Oferta',
				href: '/offer',
		},
		{
				label: 'Trening',
				href: '/training',
		},
		{
				label: 'Opinie',
				href: '/opinions',
		},
		{
				label: 'Kontakt',
				href: '/contact',
		},
		{
				label: 'FAQ',
				href: '/faq',
		},
		{
				label: 'Blog',
				href: '/blog',
		},
];

export const Navigation = () => {
		const { pathname } = useLocation();
		const deviceType = useDeviceType();
		const [menuOpen, setMenuOpen] = useState(false);
		const [scrolled, setScrolled] = useState(false);

		useEffect(() => {
				const handleScroll = () => {
						setScrolled(window.scrollY > 20);
				};
				window.addEventListener('scroll', handleScroll);
				return () => window.removeEventListener('scroll', handleScroll);
		}, []);

		const handleMenuClick = () => {
				setMenuOpen(prevState => !prevState);
		};

		return deviceType === 'monitor' ? (
				<nav
						className={`w-full fixed top-0 left-0 z-50 transition-all duration-300 ${
								scrolled
										? 'bg-white/95 backdrop-blur-md shadow-soft py-3'
										: 'bg-white/80 backdrop-blur-sm py-4'
						}`}
				>
						<div className="flex flex-row max-w-7xl mx-auto px-6 justify-between items-center">
								<Link to="/" className="flex items-center gap-3 group">
										<img
												className="w-14 h-14 transition-transform duration-300 group-hover:scale-110"
												src="/amelia-palczynska-logo.png"
												alt="Amelia Pałczyńska - Trenerka personalna kobiet"
										/>
								</Link>
								<div className="flex items-center gap-8">
										{options.map(({ label, href }) => (
												<Link
														key={href}
														to={href}
														className={`relative text-sm font-montserrat-custom-medium tracking-wide transition-all duration-300 ${
																`/${pathname.split('/')[1]}` === href
																		? 'text-primary-600 font-bold'
																		: 'text-gray-600 hover:text-primary-500'
														}`}
												>
														{label.toUpperCase()}
														<span
																className={`absolute -bottom-1 left-0 h-0.5 bg-gradient-to-r from-primary-500 to-primary-600 transition-all duration-300 ${
																		`/${pathname.split('/')[1]}` === href
																				? 'w-full'
																				: 'w-0 group-hover:w-full'
																}`}
														/>
												</Link>
										))}
										<Link
												to="/contact"
												className="ml-4 px-6 py-2.5 bg-gradient-to-r from-primary-500 to-primary-600 text-white text-sm font-bold rounded-full shadow-soft hover:shadow-soft-lg hover:scale-105 transition-all duration-300"
										>
												ZAPISZ SIĘ
										</Link>
								</div>
						</div>
				</nav>
		) : (
				<div className="relative h-16">
						<nav
								className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
										scrolled || menuOpen
												? 'bg-white/95 backdrop-blur-md shadow-soft'
												: 'bg-white/90 backdrop-blur-sm'
								}`}
						>
								<div className="flex justify-between items-center h-16 px-4">
										<Link
												to="/"
												onClick={() => menuOpen && handleMenuClick()}
										>
												<img
														className="w-10 h-10"
														src="/amelia-palczynska-logo.png"
														alt="Amelia Pałczyńska"
												/>
										</Link>
										<button
												onClick={handleMenuClick}
												className="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200"
										>
												{menuOpen ? (
														<CloseIcon
																className="text-gray-700 transition-transform duration-300 rotate-0"
																fontSize="medium"
														/>
												) : (
														<MenuIcon
																className="text-gray-700 transition-transform duration-300"
																fontSize="medium"
														/>
												)}
										</button>
								</div>
						</nav>

						<div
								className={`fixed inset-0 z-40 transition-all duration-300 ${
										menuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
								}`}
						>
								<div
										className="absolute inset-0 bg-black/30 backdrop-blur-sm"
										onClick={() => setMenuOpen(false)}
								/>
								<div
										className={`absolute top-16 left-0 right-0 bg-white shadow-soft-lg transition-all duration-300 ${
												menuOpen
														? 'translate-y-0 opacity-100'
														: '-translate-y-4 opacity-0'
										}`}
								>
										<ul className="py-4">
												{options.map(({ label, href }, index) => (
														<li
																key={href}
																className="animate-slide-down"
																style={{ animationDelay: `${index * 50}ms` }}
														>
																<Link
																		onClick={() => setMenuOpen(false)}
																		to={href}
																		className={`block px-6 py-3 text-center font-montserrat-custom-medium transition-colors duration-200 ${
																				`/${pathname.split('/')[1]}` === href
																						? 'text-primary-600 bg-primary-50 font-bold'
																						: 'text-gray-700 hover:text-primary-500 hover:bg-gray-50'
																		}`}
																>
																		{label}
																</Link>
														</li>
												))}
												<li className="px-6 pt-4 pb-2">
														<Link
																to="/contact"
																onClick={() => setMenuOpen(false)}
																className="block w-full py-3 text-center bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-full shadow-soft"
														>
																ZAPISZ SIĘ
														</Link>
												</li>
										</ul>
								</div>
						</div>
				</div>
		);
};
